<template>
  <div>
    <!-- 头部 -->
    <div class="UCenter-bg">
      <img :src="require('../../../assets/img/personal/logo.png')" class="png"  fit="scale-down"></img>
      <div style="font-size:18px;margin-top:10px;" @click="testPage()">
        学习空间预约
        <span style="font-size:14px;">v1.2.1</span>
      </div>
      <div style="font-size:14px;margin-top:20px;">
        <span></span>
      </div>
      <img :src="require('../../../assets/img/personal/wave.gif')" mode="scaleToFill" class="gif-wave"></img>
    </div>
    <van-row type="flex" style="background-color: #ffffff;padding:20px;color:#aaaaaa;">
      <van-col span="12">
        <div style="text-align: center;color:#f37b1d;padding:5px;font-size:20px;">{{sroomCount}}</div>
        <div style="text-align: center;padding:5px;font-size:14px;">研讨室参与次数</div>
      </van-col>
      <van-col span="12">
        <div style="text-align: center;color:#f37b1d;padding:5px;font-size:20px;">{{seatCount}}</div>
        <div style="text-align: center;padding:5px;font-size:14px;">座位使用次数</div>
      </van-col>
    </van-row>

    <!-- <header>
      <div class="UCenter-bg">
        <img :src="require('../../../assets/img/personal/beiji.jpg')" fit="contain" class="gif-wave"></img>
        <div class="text-xl">座位预约
          <span class="text-df">v1.1.0</span>
        </div>
        <div class="margin-top-sm">
          <span>By:安徽新天创</span>
        </div>
        <img :src="require('../../../assets/img/personal/wave.gif')" class="gif-wave"></img>
      </div>
      <div class="flex aic users pixed" style="width:50%;">
        <img :src="require('../../../assets/img/personal/tx.jpg')" class="imege" />
        <span  class="f16 fff ml-20">{{userName}}</span>
      </div>
    </header> -->

    <!-- 主体 -->
    <main class="mt-10" style="padding:0 10px;">
      <div class="bg-fff">
        <van-cell title="我的座位" isLink to="/my/mySeat"></van-cell>
        <van-cell title="我的研讨室" isLink to="/my/mySroom"></van-cell>
		<van-cell title="我的场馆" isLink to="/my/myCg"></van-cell>
        <!-- <van-cell title="修改密码" isLink to="/my/mySroom"></van-cell> -->
		<van-cell title="咨询建议" isLink isLink to="/my/suggest"></van-cell>
		<van-cell title="换卡修复"  @click="updateCard()"></van-cell>
        <van-cell title="退出" isLink @click="logout"></van-cell>
      </div>
    </main>

    <Footer page="my" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { mapGetters } from "vuex";
import { loadData , checkLogin , showToast , hideToast } from '@/utils/common'
import { Dialog , Toast } from 'vant';
export default {
  components: {
    Footer , Dialog , Toast 
  },
  data() {
    return {
      //座位尺寸
      userName:sessionStorage.getItem('login_username'),
      //推荐选座最大数量
      studentCard:sessionStorage.getItem('login_userCard'),
      sroomCount:0,
      seatCount:0,
	  clickCount:0

    }
  },
  created(){
    checkLogin();
    this.goPage();
  },
  computed: {
    ...mapGetters(["username", "isLogin"])
  },

  methods: {
    goPage(){
      let page = sessionStorage.getItem('my_targepage')
       if('seat' == page){
          this.$router.push({ path: '/my/mySeat'})
       }else if('sroom' == page){
          this.$router.push({ path: '/my/mySroom'})
       }else if('cg' == page){
          this.$router.push({ path: '/my/myCg'})
       }
       sessionStorage.setItem('my_targepage','')


      var paramsJson = {
        "userId": sessionStorage.getItem('login_userid'),
        "userPhysicalCard": sessionStorage.getItem('login_usercard')
      }
      showToast();
      loadData('/appMy/indexData',paramsJson).then(res => {
        hideToast();
        if (res.code == '0') {
          this.seatCount = res.data.seatCount
          this.sroomCount = res.data.sroomCount
        } else {
		  Toast(res.message);
        }
      })        
    },
    logout(){
      sessionStorage.clear();
      window.parent.location.reload();//刷新父页面
    },
	testPage(){
     	this.clickCount = this.clickCount + 1;
		if(this.clickCount >= 3){
			this.clickCount = 0;
			this.$router.push({ path: '/cgyy'})
		}else{
			setTimeout(function(){
				this.clickCount = 0;
			},1000);
		}
	},
	updateCard(){
		Dialog.confirm({
		  message: '确认换卡修复？',
		}).then(() => {
		   var paramsJson = {
		     "userId": sessionStorage.getItem('login_userid'),
		     "userPhysicalCard": sessionStorage.getItem('login_usercard')
		   }
		   showToast();
		   loadData('/appMy/updateCard',paramsJson).then(res => {
		     hideToast();
		     if (res.code == '0') {
		       Toast('更新成功！');
		     } else {
		       Toast(res.message);
		     }
		   }) 
		}).catch(() => {
		  //alert(2);
		});
	}
  }
};
</script>

<style lang="less" scoped>
@import "./center.less";
</style>